
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diagnostics/steps",
      function () {
        return require("private-next-pages/diagnostics/steps.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/diagnostics/steps"])
      });
    }
  